import { find } from 'lodash';

export const resolveOffers = (page = undefined, perpage = undefined, deleted = undefined) => {
  return [ 'offerService', offerService => {
    return offerService.findAll(page, perpage, deleted).then(list => list);
  }];
};

export const resolveOffer = (param = 'offer') => {
  return [ '$stateParams', 'offerService', ($stateParams, offerService) => {
    return $stateParams[param] && $stateParams[param] > 0 ? offerService.findById($stateParams[param]) : {};
  }];
};


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/resolvers/offer.resolver.js